import { useMemo, type FC, type ReactElement } from 'react';

import { AutomatedMessageToastConnected } from './exceptions/AutomatedMessageToastConnected';
import { AutoplayNotChangedToastConnected } from './exceptions/AutoplayNotChangedToastConnected';
import { GameCanceledToastConnected } from './exceptions/GameCanceledToastConnected';
import { MaxWinCapToastConnected } from './exceptions/MaxWinCapToastConnected';
import { MinBetToastConnected } from './exceptions/MinBetToastConnected';
import { SubtitlesClosedToastConnected } from './exceptions/SubtitlesClosedToastConnected';
import { TableCloseNotifyToastConnected } from './exceptions/TableCloseNotifyToastConnected';
import { ToastConnected } from './ToastConnected';
import { ToastConfig, ToastConnectedProps, ToastType } from './types';

const coreToastConfig: ToastConfig = {
  [ToastType.AUTOPLAY_CONTINUED_NO_CHANGES]: AutoplayNotChangedToastConnected,
  [ToastType.MAX_PAYOUT_REACHED]: MaxWinCapToastConnected,
  [ToastType.TABLE_WILL_CLOSE]: TableCloseNotifyToastConnected,
  [ToastType.TOAST_GAME_CANCELLED]: GameCanceledToastConnected,
  [ToastType.TOAST_AUTOMATED_MESSAGE]: AutomatedMessageToastConnected,
  [ToastType.TOAST_BET_ABOVE_MINIMUM]: MinBetToastConnected,
  [ToastType.TOAST_SUBTITLES_OFF]: SubtitlesClosedToastConnected,
  [ToastType.TOAST_SUBTITLES_GO_TO_SETTINGS]: SubtitlesClosedToastConnected,
};

export interface ToastRendererProps extends ToastConnectedProps {
  additionalToastConfig?: ToastConfig;
}

export const ToastRenderer: FC<ToastRendererProps> = ({
  additionalToastConfig,
  ...toastBaseProps
}): ReactElement | null => {
  const toastIdentifier = toastBaseProps.toasterType || toastBaseProps.message;
  if (!toastIdentifier) return null;

  const toastRegistry = useMemo(() => ({ ...coreToastConfig, ...additionalToastConfig }), [additionalToastConfig]);
  const CustomToast = toastRegistry[toastIdentifier];
  if (CustomToast) {
    return <CustomToast {...toastBaseProps} />;
  }
  return <ToastConnected {...toastBaseProps} />;
};
